import { fg } from '@atlaskit/platform-feature-flags/fg';
import { navigateToTeamsApp } from '@atlaskit/teams-app-config/navigation';

// TODO: Remove this once each product passes this value via the generateTeamUrl prop
export const getTeamPath: (
	teamId: string,
	primaryProduct: string,
	orgId: string,
	cloudId: string,
) => string | undefined = (
	teamId: string,
	primaryProduct: string,
	orgId: string,
	cloudId: string,
) => {
	if (primaryProduct === 'confluence') {
		return fg('platform-adopt-teams-nav-config')
			? navigateToTeamsApp({
					type: 'TEAM',
					payload: {
						teamId,
					},
					cloudId,
					hostProduct: 'confluence',
				}).href
			: `/wiki/people/team/${teamId}`;
	} else if (primaryProduct === 'townsquare') {
		return fg('platform-adopt-teams-nav-config')
			? navigateToTeamsApp({
					type: 'TEAM',
					payload: {
						teamId,
					},
					cloudId,
				}).href
			: `/o/${orgId}/people/team/${teamId}?cloudId=${cloudId}`;
	}
};
